module.exports = __webpack_public_path__ + "static/media/camera-S.inline.b957244c.svg";